import React from 'react';
import { RouteObject } from 'react-router-dom';
import { dossiersBasePath } from '@europrocurement/l2d-modules';
import {
    addFormalityPath,
    listeDossiersPath,
    detailDossierPath,
    dossierValidationPath,
} from './constants';
import { DossierRoot, AddFormality, DetailDossier, InfoValidation, ListeDossiers } from './views';

export const DossierRouter: RouteObject = {
    path: dossiersBasePath,
    element: <DossierRoot />,
    children: [
        {
            path: listeDossiersPath,
            element: <ListeDossiers />,
        },
        {
            path: detailDossierPath,
            element: <DetailDossier />,
        },
        {
            path: dossierValidationPath,
            element: <InfoValidation />,
        },
        {
            path: addFormalityPath,
            element: <AddFormality />,
        },
    ],
};
